/** Line icons at a shared 24-grid, 1.75 stroke. Inherit `currentColor`. */

type P = { className?: string }

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
}

export const IconToday = ({ className = 'nav__icon' }: P) => (
  <svg {...base} className={className}>
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4" />
    <circle cx="12" cy="12" r="4" />
  </svg>
)

export const IconCalendar = ({ className = 'nav__icon' }: P) => (
  <svg {...base} className={className}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
)

export const IconStudy = ({ className = 'nav__icon' }: P) => (
  <svg {...base} className={className}>
    <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H19v14H5.5A1.5 1.5 0 0 0 4 19.5z" />
    <path d="M4 19.5A1.5 1.5 0 0 1 5.5 18H19v3H5.5" />
    <path d="M9 8h6" />
  </svg>
)

export const IconJourney = ({ className = 'nav__icon' }: P) => (
  <svg {...base} className={className}>
    <path d="m12 3 9 5-9 5-9-5z" />
    <path d="M20 9.5V14c0 2.2-3.6 4-8 4s-8-1.8-8-4V9.5" />
  </svg>
)

export const IconLibrary = ({ className = 'nav__icon' }: P) => (
  <svg {...base} className={className}>
    <path d="M9 18V6l10-2v12" />
    <circle cx="6.5" cy="18" r="2.5" />
    <circle cx="16.5" cy="16" r="2.5" />
  </svg>
)

export const IconSettings = ({ className = 'nav__icon' }: P) => (
  <svg {...base} className={className}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 9 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.6 9a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z" />
  </svg>
)

export const IconPlus = ({ className = '' }: P) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="M12 5v14M5 12h14" />
  </svg>
)

export const IconPlay = ({ className = '' }: P) => (
  <svg {...base} className={className} width="14" height="14" fill="currentColor" stroke="none">
    <path d="M8 5.5v13l11-6.5z" />
  </svg>
)

export const IconPause = ({ className = '' }: P) => (
  <svg {...base} className={className} width="14" height="14" fill="currentColor" stroke="none">
    <path d="M8 5h3v14H8zM13 5h3v14h-3z" />
  </svg>
)

export const IconPrev = ({ className = '' }: P) => (
  <svg {...base} className={className} width="14" height="14" fill="currentColor" stroke="none">
    <path d="M7 5h2.2v14H7zM19 5.5v13l-9-6.5z" />
  </svg>
)

export const IconNext = ({ className = '' }: P) => (
  <svg {...base} className={className} width="14" height="14" fill="currentColor" stroke="none">
    <path d="M14.8 5H17v14h-2.2zM5 5.5v13l9-6.5z" />
  </svg>
)

export const IconChevron = ({ className = '' }: P) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="m9 6 6 6-6 6" />
  </svg>
)

export const IconTrash = ({ className = '' }: P) => (
  <svg {...base} className={className} width="15" height="15">
    <path d="M4 7h16M10 11v6M14 11v6M5.5 7l1 12.5A1.5 1.5 0 0 0 8 21h8a1.5 1.5 0 0 0 1.5-1.5L18.5 7M9 7V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V7" />
  </svg>
)
